import { useQuery } from "@tanstack/react-query";

import { getProductCatalogCategories } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import keys from "../keys";

export const useProductCategoriesQuery = () => {
	return useQuery({
		queryKey: keys.productCategories(),
		queryFn: processResponse(() => getProductCatalogCategories()),
	});
};
